import React from "react";
import Page from "../components/ui/Page";
import Holidays from "../components/holidays/Holidays";

export default function HolidaysPage() {
    return <Page hideBackButton>
        <Holidays/>
    </Page>;
};